import { render, staticRenderFns } from "./DashboardRTL.vue?vue&type=template&id=8ad1765e"
import script from "./DashboardRTL.vue?vue&type=script&lang=js"
export * from "./DashboardRTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports